<template>
    <div>
        <div class="pl-3 pr-3 border-solid border-gray-200 border-2">
            <v-form ref="myform" v-model="isformvalid">
                <v-jsf v-model="formmodel" :schema="formschema" :options="formoptions">
                    <template slot="profile_photo_path" slot-scope="context">
                        <v-avatar width="200" height="200" v-bind="context" v-if="(formmodel.profile_photo_path)" tile>
                            <v-img :src="'/storage/' + formmodel.profile_photo_path"></v-img>
                        </v-avatar>
                    </template>
                    <template slot="name" slot-scope="context">
                        <v-text-field v-bind="context" v-model="formmodel.name" ref="fldfirst" maxlength="255" readonly></v-text-field>
                    </template>
                    <template slot="password" slot-scope="{ label }">
                        <v-text-field :label="label" v-model="formmodel.password" :readonly="fieldlocked" type="password"></v-text-field>
                    </template>
                    <template slot="email" slot-scope="context">
                        <v-text-field v-bind="context" v-model="formmodel.email" maxlength="255" readonly></v-text-field>
                    </template>
                    <template slot="icno" slot-scope="context">
                        <v-text-field v-bind="context" v-model="formmodel.icno" maxlength="7" readonly></v-text-field>
                    </template>
                    <template slot="contactno" slot-scope="context">
                        <v-text-field v-bind="context" v-model="formmodel.contactno" maxlength="20" readonly></v-text-field>
                    </template>
                </v-jsf>
            </v-form>
            <v-card-actions>
                <v-spacer></v-spacer>
                <!-- <v-btn color="primary" dark @click="newItem" v-if="mode === ''">
                    <v-icon left>mdi-text-box-plus-outline</v-icon>
                    New
                </v-btn> -->
                <v-btn color="blue darken-3" dark @click="savethis" v-if="mode !== ''">
                    <v-icon left>mdi-content-save</v-icon>
                    Update
                </v-btn>
                <v-btn color="red darken-3" dark @click="cancel" v-if="mode != ''">
                    <v-icon left>mdi-close</v-icon>
                    Cancel
                </v-btn>
            </v-card-actions>
        </div>
        <div class="pa-4 mt-3 border-solid border-gray-200 border-2">
            <v-data-table dense
                :headers="headers"
                :items="filtereddata()"
                item-key="id"
                v-model="selecteditems"
                no-data-text="No record"
                no-results-text="No record"
            >
                <template v-slot:[`header.name`]="{ header }">
                    {{ header.text }}
                    <v-menu offset-y :close-on-content-click="false" min-width="300">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                                <v-icon small :color="txtname ? 'primary' : ''">mdi-filter</v-icon>
                            </v-btn>
                        </template>
                        <div class="bg-white pa-2">
                            <v-text-field v-model="txtname" label="Name" outlined></v-text-field>
                            <v-btn @click="txtname = ''" small text color="primary" class="ml-2 mb-2">Clear</v-btn>
                        </div>
                    </v-menu>
                </template>
                <template v-slot:[`header.icno`]="{ header }">
                    {{ header.text }}
                    <v-menu offset-y :close-on-content-click="false" min-width="300">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                                <v-icon small :color="txticno ? 'primary' : ''">mdi-filter</v-icon>
                            </v-btn>
                        </template>
                        <div class="bg-white pa-2">
                            <v-text-field v-model="txticno" label="IC Number" outlined dense></v-text-field>
                            <v-btn @click="txticno = ''" small text color="primary" class="ml-2 mb-2">Clear</v-btn>
                        </div>
                    </v-menu>
                </template>
                <template v-slot:[`header.email`]="{ header }">
                    {{ header.text }}
                    <v-menu offset-y :close-on-content-click="false" min-width="300">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                                <v-icon small :color="txtemail ? 'primary' : ''">mdi-filter</v-icon>
                            </v-btn>
                        </template>
                        <div class="bg-white pa-2">
                            <v-text-field v-model="txtemail" label="Email" outlined dense></v-text-field>
                            <v-btn @click="txtemail = ''" small text color="primary" class="ml-2 mb-2">Clear</v-btn>
                        </div>
                    </v-menu>
                </template>
                <template v-slot:[`header.contactno`]="{ header }">
                    {{ header.text }}
                    <v-menu offset-y :close-on-content-click="false" min-width="300">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                                <v-icon small :color="txtcontactno ? 'primary' : ''">mdi-filter</v-icon>
                            </v-btn>
                        </template>
                        <div class="bg-white pa-2">
                            <v-text-field v-model="txtcontactno" label="Contact No." outlined dense></v-text-field>
                            <v-btn @click="txtcontactno = ''" small text color="primary" class="ml-2 mb-2">Clear</v-btn>
                        </div>
                    </v-menu>
                </template>
                <template v-slot:[`header.usertype`]="{ header }">
                    {{ header.text }}
                    <v-menu offset-y :close-on-content-click="false" min-width="300">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                                <v-icon small :color="txtusertype ? 'primary' : ''">mdi-filter</v-icon>
                            </v-btn>
                        </template>
                        <div class="bg-white pa-2">
                            <v-select v-model="txtusertype" :items="ddusertypes" item-value="code" item-text="description" label="User Types"></v-select>
                            <v-btn @click="txtusertype = ''" small text color="primary" class="ml-2 mb-2">Clear</v-btn>
                        </div>
                    </v-menu>
                </template>
                <template v-slot:[`header.lastlogin`]="{ header }">
                    {{ header.text }}
                    <v-menu offset-y :close-on-content-click="false" min-width="300">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                                <v-icon small :color="txtlastlogin ? 'primary' : ''">mdi-filter</v-icon>
                            </v-btn>
                        </template>
                        <div class="bg-white pa-2">
                            <v-date-picker v-model="txtlastlogin"></v-date-picker>
                            <v-btn @click="txtlastlogin = ''" small text color="primary" class="ml-2 mb-2">Clear</v-btn>
                        </div>
                    </v-menu>
                </template>
                <template v-slot:[`header.status`]="{ header }">
                    {{ header.text }}
                    <v-menu offset-y :close-on-content-click="false" min-width="300">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                                <v-icon small :color="txtstatus ? 'primary' : ''">mdi-filter</v-icon>
                            </v-btn>
                        </template>
                        <div class="bg-white pa-2">
                            <v-select v-model="txtstatus" :items="ddstatus" item-value="code" item-text="description" label="Account Status"></v-select>
                            <v-btn @click="txtstatus = ''" small text color="primary" class="ml-2 mb-2">Clear</v-btn>
                        </div>
                    </v-menu>
                </template>
                <template v-slot:[`item.no`]="{ item }">
                    <small>{{ users.indexOf(item) + 1 }}</small>
                </template>
                <template v-slot:[`item.name`]="{ item }">
                    <small>{{ item.name }}</small>
                </template>
                <template v-slot:[`item.icno`]="{ item }">
                    <small>{{ item.icno }}</small>
                </template>
                <template v-slot:[`item.email`]="{ item }">
                    <small>{{ item.email }}</small>
                </template>
                <template v-slot:[`item.contactno`]="{ item }">
                    <small>{{ item.contactno }}</small>
                </template>
                <template v-slot:[`item.usertype`]="{ item }">
                    <small>{{ formatusertype(item.usertype) }}</small>
                </template>
                <template v-slot:[`item.lastlogin`]="{ item }">
                    <small>{{ formatdatetime(item.lastlogin) }}</small>
                </template>
                <template v-slot:[`item.status`]="{ item }">
                    <small>{{ formatstatus(item.status) }}</small>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <v-icon class="mr-2" small color="black" @click="editItem(item)" :disabled="item.id === 1">mdi-pencil</v-icon>
                    <!-- <v-icon color="black" small @click="deleteItem(item)" :disabled="item.id === 1">mdi-delete</v-icon> -->
                </template>
                <!-- <template v-slot:[`body.append`]>
                    <td colspan="6">
                        <v-select class="w-40 mt-3" :items="multifunctions" item-value="type" item-text="name" v-model="selmultifunc" placeholder="Bulk Operation" @change="execmfunc" dense/>
                    </td>
                </template> -->
            </v-data-table>
            <v-dialog v-model="dlgdelete" width="450" dark dense>
                <v-card dense>
                    <v-card-title class="title"><span class="text-white">Delete this record?</span></v-card-title>
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="4">No.</v-col>
                            <v-col cols="8">{{ deleteditem.no }}</v-col>
                            <v-col cols="4">Name</v-col>
                            <v-col cols="8">{{ deleteditem.name }}</v-col>
                            <v-col cols="4">Email</v-col>
                            <v-col cols="8">{{ deleteditem.email }}</v-col>
                            <v-col cols="4">QID No.</v-col>
                            <v-col cols="8">{{ deleteditem.icno }}</v-col>
                            <v-col cols="4">Contact No.</v-col>
                            <v-col cols="8">{{ deleteditem.contactno }}</v-col>
                            <v-col cols="4">User Type</v-col>
                            <v-col cols="8">{{ formatusertype(deleteditem.usertype) }}</v-col>
                            <v-col cols="4">Status</v-col>
                            <v-col cols="8">{{ formatstatus(deleteditem.status) }}</v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-3" dark @click="deletethis()" :disabled="((deleteditem.usertype === 'sysadmins') && (deleteditem.id === 1))">
                            <v-icon left>mdi-delete</v-icon>
                            Delete
                        </v-btn>
                        <v-btn color="red darken-3" dark @click="canceldelete">
                            <v-icon left>mdi-close</v-icon>
                            Cancel
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
        <v-snackbar v-model="sbmsg" timeout="5000" color="green darken-4" dark centered>
            <div v-html="msg"></div>
            <template v-slot:action="{ attrs }">
                <v-btn color="white" text v-bind="attrs" @click="sbmsg = false">
                    Close
                </v-btn>
            </template>
        </v-snackbar>
        <v-snackbar v-model="sberrmsg" timeout="5000" color="red darken-4" dark centered>
            <div v-html="msg"></div>
            <template v-slot:action="{ attrs }">
                <v-btn color="white" text v-bind="attrs" @click="sberrmsg = false">
                    Close
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
const axios = require('axios')
import GeneralOptions from '../Forms/GeneralOptions'
import SystemUserOperatorModel from '../Forms/SystemUserOperatorModel'
import SystemUserOperatorSchema from '../Forms/SystemUserOperatorSchema'

export default {
    name: 'TableSystemUserOperators',
    components: {},
    props: {},
    data() {
        return {
            isformvalid: false,
            formoptions: GeneralOptions,
            formmodel: SystemUserOperatorModel,
            formschema: SystemUserOperatorSchema,
            users: [],
            headers: [
                { text: "No.",              value: "no",        sortable: false, align: "start", width: '40px' },
                { text: "Name",             value: "name",      sortable: false },
                { text: "QID No.",          value: "icno",      sortable: false },
                { text: "Email",            value: "email",     sortable: false },
                { text: "Contact No.",      value: "contactno", sortable: false },
                { text: "User Type",        value: "usertype",  sortable: false },
                { text: "Last Login",       value: "lastlogin", sortable: false },
                { text: "Status",           value: "status",    sortable: false },
                { text: "Operations",       value: "actions",   sortable: false, align: 'end', width: '100px' }
            ],
            mode: null,
            editeditem: {
                no: 0,
                id: 0,
                name: '',
                password: '',
                email: '',
                usertype: '',
                status: '',
            },
            deleteditem: {
                no: 0,
                id: 0,
                name: '',
                password: '',
                email: '',
                icno: '',
                contactno: '',
                usertype: '',
                status: '',
            },
            newitem: {
                name: '',
                email: '',
                password: '',
                usertype: 'operators',
                status: '01',
            },
            dlgdelete: false,
            sbmsg: false,
            sberrmsg: false,
            msg: '',
            selecteditems: [],
            multifunctions: [
                // multi selection functions
                { type: null, name: 'Bulk Operation' }, // default
                { type: 'MDEL', name: 'Delete selected' },
            ],
            selmultifunc: null,
            ismounted: false,
            fieldlocked: false,
            txtname: '',
            txticno: '',
            txtemail: '',
            txtcontactno: '',
            txtusertype: '',
            txtlastlogin: '',
            txtstatus: '',
            ddusertypes: [
                {
                    code: '',
                    description: 'None selected'
                },
                {
                    code: 'sysadmins',
                    description: 'System Administrators'
                },
                {
                    code: 'bizpartners',
                    description: 'Business Partners'
                },
                {
                    code: 'operators',
                    description: 'Operators'
                }
            ],
            ddstatus: [
                {
                    code: '',
                    description: 'None selected'
                },
                {
                    code: '01',
                    description: 'Active'
                },
                {
                    code: '02',
                    description: 'Disabled'
                }
            ],
        }
    },
    watch: {
        mode: function (newval, oldval) {
            if (newval === '')  {
                // lock the form entry
                this.lockallfields(true)
                return
            }
            if (((newval === 'NEW') || (newval === 'EDIT')) && (oldval === '')) {
                // unlock the form entry
                this.lockallfields(false)
                return
            }
        }
    },
    mounted: function () {
        this.initialize()
    },
    methods: {
        lockallfields(pSwitch) {
            this.fieldlocked = pSwitch // any custom field
            const vjsfprops = this.formschema.properties
            for (const field in vjsfprops) {
                if ((field !== 'usertype') && (field !== 'status')) {
                    if (vjsfprops[field]['x-props']) {
                        vjsfprops[field]['x-props']['readonly'] = pSwitch
                    }
                }
            }
        },

        initialize() {
            this.$nextTick(() => {
                this.getusers()
                this.ismounted = true
                this.mode = ''
                this.editeditem = Object.assign({}, this.newitem)
                this.formmodel = Object.assign({}, this.newitem)
                this.selecteditems = []
                this.multifunc = ''

                this.txtname = ''
                this.txticno = ''
                this.txtemail = ''
                this.txtcontactno = ''
                this.txtusertype = ''
                this.txtlastlogin = ''
                this.txtstatus = ''
            })
        },

        getusers() {
            var targetPath = '/bizpartner/operators/all'
            axios.get(targetPath)
            .then((resp) => {
                if (resp.data) {
                    var rtn = resp.data
                    if (rtn.status === 'OK') {
                        this.users = rtn.data
                    } else {
                        this.users = []
                    }
                }
            })
        },

        filtereddata() {
            var conditions = []

            if (this.txtname) { conditions.push(this.filtername) }
            if (this.txticno) { conditions.push(this.filtericno) }
            if (this.txtemail) { conditions.push(this.filteremail) }
            if (this.txtcontactno) { conditions.push(this.filtercontactno) }
            if (this.txtusertype) { conditions.push(this.filterusertype) }
            if (this.txtlastlogin) { conditions.push(this.filterlastlogin) }
            if (this.txtstatus) { conditions.push(this.filterstatus) }

            if (conditions.length > 0) {
                return this.users.filter((item) => {
                    return conditions.every((condition) => {
                        return condition(item)
                    })
                })
            }

            return this.users
        },

        filtername(item) {
            return (item.name) ? item.name.toLowerCase().includes(this.txtname.toLowerCase()) : null
        },

        filtericno(item) {
            return (item.icno) ? item.icno.includes(this.txticno) : null
        },

        filteremail(item) {
            return (item.email) ? item.email.toLowerCase().includes(this.txtemail.toLowerCase()) : null
        },

        filtercontactno(item) {
            return (item.contactno) ? item.contactno.toLowerCase().includes(this.txtcontactno.toLowerCase()) : null
        },

        filterusertype(item) {
            return item.usertype.includes(this.txtusertype)
        },

        filterlastlogin(item) {
            return item.lastlogin.includes(this.txtlastlogin)
        },

        filterstatus(item) {
            return item.status.includes(this.txtstatus)
        },

        formatdatetime(e) {
            if (e === null) return ''
            return this.$moment(new Date(e)).format('DD/MM/YYYY h:mm:ss A')
        },

        formatusertype(e) {
            if (!e) return ''
            if (e === 'sysadmins') return 'System Administrator'
            if (e === 'bizpartners') return 'Business Partner'
            if (e === 'operators') return 'Operator'
        },

        formatstatus(e) {
            if (!e) return ''
            if (e === '01') return 'Active'
            if (e === '02') return 'Disabled'
        },

        newItem() {
            this.editeditem = Object.assign({}, this.newitem)
            this.formmodel = Object.assign({}, this.newitem)
            this.mode = 'NEW'
            this.$refs.fldfirst.focus()
        },

        editItem(itm) {
            this.editeditem = Object.assign({}, itm)
            this.formmodel = Object.assign({}, itm)
            this.formmodel.password = null
            this.mode = 'EDIT'
            this.$refs.fldfirst.focus()
        },

        deleteItem(itm) {
            this.deleteditem = Object.assign({}, itm)
            this.deleteditem.no = this.users.indexOf(itm) + 1
            this.dlgdelete = true
        },

        canceldelete() {
            this.deleteditem = Object.assign({}, this.newitem)
            this.dlgdelete = false
        },

        cancel() {
            this.formmodel = Object.assign({}, this.newitem)
            this.mode = ''
        },

        savethis() {
            var targetPath = ''

            if (!this.isformvalid) {
                this.msg = 'Data incomplete. Cannot continue with add or update.'
                this.sberrmsg = true
                this.cancel()
                return
            }

            var data = new FormData()
            if (this.mode === 'NEW') {
                targetPath = '/admin/system-users/add'
                data.append('name', this.formmodel.name)
                data.append('email', this.formmodel.email)
                if (this.formmodel.password !== '') {
                    data.append('password', this.formmodel.password)
                } else {
                    this.msg = 'New record must require a password'
                    this.sberrmsg = true
                    return
                }
                data.append('icno', this.formmodel.icno)
                data.append('contactno', this.formmodel.contactno)
                data.append('usertype', this.formmodel.usertype)
                data.append('status', this.formmodel.status)
            }

            if (this.mode === 'EDIT') {
                targetPath = '/admin/system-users/update'
                data.append('id', this.editeditem.id)
                data.append('name', this.formmodel.name)
                data.append('email', this.formmodel.email)
                if (this.formmodel.password !== '') {
                    data.append('password', this.formmodel.password)
                }
                data.append('icno', this.formmodel.icno)
                data.append('contactno', this.formmodel.contactno)
                data.append('usertype', this.formmodel.usertype)
                data.append('status', this.formmodel.status)
            }

            axios.post(targetPath, data)
            .then((resp) => {
                if (resp.data) {
                    var rtn = resp.data
                    if (rtn.status === 'OK') {
                        this.msg = rtn.message
                        this.sbmsg = true
                        this.initialize()
                    } else {
                        this.msg = rtn.error
                        this.sberrmsg = true
                        this.cancel()
                    }
                }
            })

        },

        deletethis() {
            var targetPath = '/admin/system-users/delete'
            var data = {
                id: this.deleteditem.id,
            }

            axios.post(targetPath, data)
            .then((resp) => {
                if (resp.data) {
                    var rtn = resp.data
                    this.canceldelete()
                    if (rtn.status === 'OK') {
                        this.msg = rtn.message
                        this.sbmsg = true
                        this.initialize()
                    } else {
                        this.msg = rtn.error
                        this.sberrmsg = true
                    }
                }
            })
        },

        deleteselected() {
            var targetPath = '/admin/system-users/deleteselected'
            var data = new FormData()

            data.append('todelete', JSON.stringify(this.selecteditems))

            axios.post(targetPath, data, {
                headers: {
                    'ContentType': 'application/json' // coz we're passing an array
                }
            })
            .then((resp) => {
                if (resp.data) {
                    var rtn = resp.data
                    if (rtn.status === 'OK') {
                        this.initialize()
                        this.msg = rtn.message
                        this.sbmsg = true
                    } else {
                        this.msg = rtn.error
                        this.sberrmsg = true
                    }
                    this.$nextTick(() => {
                        this.selmultifunc = null // reset
                        this.selecteditems = [] // reset
                    })
                }
            })
        },

        execmfunc() {
            if (this.selmultifunc === 'MDEL') { // multiple delete
                // check if anything was selected
                if (this.selecteditems.length === 0) {
                this.msg = 'No records are selected for deletion'
                this.sberrmsg = true
                this.$nextTick(() => {
                    this.selmultifunc = null // reset
                })
                return
                }
                // check if user.id = 1 is selected
                for (var i = 0; i < this.selecteditems.length; i++)
                {
                const itm = this.selecteditems[i]
                if (itm.id === 1) {
                    this.msg = 'Main system administrator account cannot be deleted'
                    this.sberrmsg = true
                    this.$nextTick(() => {
                        this.selmultifunc = null // reset
                        this.selecteditems = []
                    })
                    return
                }
                }
                this.deleteselected()
            }
        },
    },
}
</script>
